'use client'

import { Avatar, Icon, IconComponent } from '@graftcode/design-system'

import { MOBILE_MENU_TEST_IDS } from '@common/common-test-ids.const'

import { useMobileMenuContext } from '../../context'

import styles from '../../MobileMenu.module.scss'

export function MobileMenuFooter() {
  const { displayWorkspaceInitials, displayWorkspaceName, setCurrentView } = useMobileMenuContext()

  return (
    <div className={styles.footer} data-testid={MOBILE_MENU_TEST_IDS.footer}>
      <button className={styles.workspaceSelector} onClick={() => setCurrentView('workspaces')}>
        <Avatar size={32} fallback={displayWorkspaceInitials} />
        <div className={styles.workspaceSelectorText}>
          <span className={styles.workspaceSelectorName}>{displayWorkspaceName}</span>
          <span className={styles.workspaceSelectorLabel}>{displayWorkspaceName}</span>
        </div>
        <IconComponent icon={Icon.ChevronRightRegular} size={20} />
      </button>
    </div>
  )
}
